<script setup>
import { onMounted } from 'vue'
import { startClock } from './utils/dateUtils.js'

onMounted(() => {
  startClock()
})
</script>

<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<style>
</style>
